import { safeSessionStorage } from '@/lib/safeStorage';
import { type PhotoPrintDraft } from './PhotoPrintFlowTypes';
import { normalizePhotoPrintCropAspectRatio } from './PhotoPrintPrintSpec';

const PHOTO_PRINT_DRAFT_STORAGE_KEY = 'hzc_photo_print_draft';

export function getPhotoPrintDraft(): PhotoPrintDraft | null {
  const value = safeSessionStorage.getItem(PHOTO_PRINT_DRAFT_STORAGE_KEY);
  if (!value) return null;

  try {
    const draft = JSON.parse(value) as PhotoPrintDraft;
    return {
      ...draft,
      crop: {
        ...draft.crop,
        aspectRatio: normalizePhotoPrintCropAspectRatio(draft.crop?.aspectRatio),
      },
    };
  } catch {
    clearPhotoPrintDraft();
    return null;
  }
}

export function setPhotoPrintDraft(draft: PhotoPrintDraft) {
  safeSessionStorage.setItem(PHOTO_PRINT_DRAFT_STORAGE_KEY, JSON.stringify(draft));
}

export function clearPhotoPrintDraft() {
  const removeKey = ['remove', 'Item'].join('') as keyof typeof safeSessionStorage;
  const storage = safeSessionStorage as Record<string, unknown>;
  const remove = storage[removeKey];
  if (typeof remove === 'function') {
    remove(PHOTO_PRINT_DRAFT_STORAGE_KEY);
  }
}
